// Quality values must match the quality prop used in the rendering component.
// A mismatch produces a different /_next/image URL, making the preload a no-op.
export const DESKTOP_IMAGE_QUALITY = 75; // ZoomableImage
export const MOBILE_IMAGE_QUALITY = 70; // MobileImageGallery (first slide)
export const THUMBNAIL_IMAGE_QUALITY = 50; // ProductPreview thumbnails
export const HOMEPAGE_BACKGROUND_IMAGE_QUALITY = 50; // Testimonials full-bleed background images
// HeroBanner exposes no `quality` prop, so its images always render at
// next/image's default q=75 — a hero preload must use 75, not the 50 above.
export const HERO_IMAGE_QUALITY = 75;

export const THUMBNAIL_WIDTHS = [256, 384, 640, 750, 828];
// Next.js default `deviceSizes`. HeroBanner renders sizes="100vw", so
// next/image emits every deviceSize in the img srcset; the preload srcset
// must list the same candidates or the browser may fetch a second variant.
export const FULL_BLEED_IMAGE_WIDTHS = [
  640, 750, 828, 1080, 1200, 1920, 2048, 3840,
];
export const LARGE_IMAGE_WIDTHS = [640, 750, 828, 1080, 1200, 1920];
// 1080 covers Lighthouse mobile simulation (360px × 3x DPR) and 360px@3x Android phones.
export const MOBILE_IMAGE_WIDTHS = [640, 750, 828, 1080];

export const PRODUCT_THUMBNAIL_SIZES =
  '(max-width: 479px) calc(50vw - 20px), (max-width: 1099px) calc(50vw - 24px), calc(25vw - 40px)';

export const PRODUCT_IMAGE_DESKTOP_SIZES =
  '(min-width: 1440px) 660px, (min-width: 1280px) 620px, (min-width: 1100px) 520px, 375px';

export const PRODUCT_IMAGE_MOBILE_SIZES = '(max-width: 768px) 100vw, 343px';

export function buildImagePreloadSrcSet(
  src: string,
  widths: number[],
  quality: number,
): string {
  const u = encodeURIComponent(src);
  return widths
    .map((w) => `/_next/image?url=${u}&w=${w}&q=${quality} ${w}w`)
    .join(', ');
}

export function buildImagePreloadHref(
  src: string,
  width: number,
  quality: number,
): string {
  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality}`;
}
